import { ProductBuilderMachineState } from '../../types';
import { VenetianBlindsProductType } from '../productTypes';

type VenetianBlindsStatesByProductType = {
  [key in VenetianBlindsProductType]: ProductBuilderMachineState[];
};

export const allVenetianBlindsStates: ProductBuilderMachineState[] = [
  'colour',
  'slatSize',
  'driveControl',
  // 'designerTape',
  'fitting',
  'measurements',
  'venetianValance',
  // 'measureInsurance',
  'tiltControl',
  'tiltPosition',
  'liftPosition',
  // venetianValance goes here
  'roomName',
  // 'shipping',
  'complete',
];

const venetianAluminiumStates = allVenetianBlindsStates.filter(state => {
  const blackList: ProductBuilderMachineState[] = [
    'designerTape',
    'driveControl',
    'venetianValance',
  ];
  return !blackList.includes(state);
});

const venetianPvcCorded = allVenetianBlindsStates.filter(state => {
  const blackList: ProductBuilderMachineState[] = [
    'tiltControl',
    'designerTape',
  ];
  return !blackList.includes(state);
});

const venetianPvcCordless = allVenetianBlindsStates.filter(state => {
  const blackList: ProductBuilderMachineState[] = [
    'tiltControl',
    'designerTape',
    'liftPosition',
  ];
  return !blackList.includes(state);
});

const venetianTimberCorded = allVenetianBlindsStates.filter(state => {
  const blackList: ProductBuilderMachineState[] = [
    'tiltControl',
    'designerTape',
  ];
  return !blackList.includes(state);
});

const venetianTimberCordless = allVenetianBlindsStates.filter(state => {
  const blackList: ProductBuilderMachineState[] = [
    'tiltControl',
    'designerTape',
    'liftPosition',
  ];
  return !blackList.includes(state);
});

export const venetianBlindsStatesByProductType: VenetianBlindsStatesByProductType = {
  'Venetian Aluminium': venetianAluminiumStates,
  'Venetian PVC Cordless': venetianPvcCordless,
  'Venetian PVC Corded': venetianPvcCorded,
  'Venetian Timber Cordless': venetianTimberCordless,
  'Venetian Timber Corded': venetianTimberCorded,
};
